<template>
  <div class="pb50" v-loading="loading">
    <el-form size="small" ref="form" :model="form" label-width="150px" v-if="!loading">

      <!-- 详情信息管理 -->
      <div class="detail-management-section">
         <div class="common-form">详情信息管理</div>
     
        
        <!-- 添加详情按钮 - 只在没有详情时显示 -->
        <div class="common-level-rail" v-if="!hasDetail && !detailLoading">
          <el-button
            size="small"
            icon="el-icon-plus"
            type="primary"
            @click="addClick"
            >添加详情信息</el-button
          >
          <div class="tip-text">
            <i class="el-icon-info"></i> 每个企业只能添加一条详情信息
          </div>
        </div>

        <!-- 详情表格 -->
        <div class="table-wrap" v-if="hasDetail">
          
          <el-table
            size="small"
            :data="detailTableData"
            border
            style="width: 100%"
            v-loading="detailLoading"
            empty-text="暂无详情信息"
          >
            <el-table-column
              prop="name"
              label="所属协会"
              width="180"
            ></el-table-column>
            <el-table-column prop="address" label="地址" width="200"></el-table-column>
            <el-table-column prop="phone" label="电话" width="120"></el-table-column>
            <el-table-column prop="email" label="邮箱" width="150"></el-table-column>
            <el-table-column prop="sort" label="排序" width="80"></el-table-column>
            <el-table-column
              prop="create_time"
              label="创建时间"
              width="150"
            ></el-table-column>
            <el-table-column fixed="right" label="操作" width="180">
              <template slot-scope="scope">
                <el-button
                  @click="previewClick(scope.row)"
                  type="text"
                  size="small"
                  icon="el-icon-view"
                  >预览</el-button
                >
                <el-button
                  @click="editClick(scope.row)"
                  type="text"
                  size="small"
                  icon="el-icon-edit"
                  >编辑</el-button
                >
                <el-button
                  @click="deleteClick(scope.row)"
                  type="text"
                  size="small"
                  icon="el-icon-delete"
                  style="color: #f56c6c;"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>

        <!-- 加载状态 -->
        <div v-if="detailLoading" class="loading-container">
          <i class="el-icon-loading"></i> 加载详情信息中...
        </div>
      </div>
      <!--基础设置-->
      <Basic :form="form" :gradeList="gradeList" :app_id="app_id" :category="category" :is_edit="is_edit"></Basic>
      
      
    </el-form>

    <!--提交-->
    <div class="common-button-wrapper">
      <el-button size="small" @click="cancelFunc">取消</el-button>
      <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
    </div>

    <!-- 添加详情弹窗 -->
    <Add 
      :open_add="open_add" 
      :role="role" 
      :supply_id="form.supply_id" 
      v-if="open_add" 
      @close="closeAddFunc"
    ></Add>
    
    <!-- 编辑详情弹窗 -->
    <Edit
        :open_edit="open_edit"
      :supply_detail_id="supply_detail_id"
      v-if="open_edit"
      @close="closeEditFunc"
      :role="role"
      :supply_id="form.supply_id"
    ></Edit>

    <!-- 预览弹窗 -->
    <el-dialog
      title="企业详情预览"
      :visible.sync="open_preview"
      width="375px"
      top="3vh"
      @close="closePreviewFunc"
      custom-class="preview-dialog"
    >
      <div class="preview-container">
        <div class="preview-header">
          <span class="preview-title">{{ preview_data.name || '企业详情预览' }}</span>
          <div class="preview-actions">
            <el-button
              size="small"
              @click="refreshIframe"
              icon="el-icon-refresh"
              >刷新</el-button
            >
            <el-button
              size="small"
              @click="openInNewWindow"
              icon="el-icon-position"
              >新窗口</el-button
            >
          </div>
        </div>
        <div class="iframe-container">
          <iframe
            :src="previewUrl"
            width="100%"
            height="667"
            frameborder="0"
            scrolling="auto"
            :key="iframeKey"
            @load="iframeLoaded"
            ref="previewIframe"
            allow="fullscreen"
          ></iframe>
        </div>
        <div class="preview-loading" v-if="iframeLoading">
          <i class="el-icon-loading"></i> 加载预览页面中...
        </div>
      </div>
      
      <div slot="footer" class="dialog-footer">
        <el-button @click="closePreviewFunc" size="small">关闭预览</el-button>
        <el-button 
          type="primary" 
          @click="copyPreviewLink" 
          size="small"
          icon="el-icon-document-copy"
        >
          复制链接
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import SupplyApi from '@/api/supply.js';
import Supply_detailApi from "@/api/supply_detail.js";
import Basic from './part/Basic.vue';

import Add from "./part/add.vue";
import Edit from "./part/edit.vue";

export default {
  name: 'SupplyEdit',
  components: {
    Basic,
    Add,
    Edit
  },
  data() {
    return {
      /*是否正在加载*/
      loading: true,
      /*详情加载状态*/
      detailLoading: false,
      /*表单对象*/
      form: {
        supply_id: 0,
        image_id: 0,
        kmd_grade_id: 0,
        name: '',
        status: 1,
        self_manage: 0,
        user_id: '',
        user_name: '',
        password: '',
        introduce: '',
        remark: '',
        sort: 100,
        is_forbidden_buy: 0,
        product_show: 'two_column',
        notice: ""
      },
      gradeList: [],
      app_id: 0,
      is_edit: true,
      category: [],
      
      // 详情相关数据
      detailTableData: [],
      hasDetail: false,
      open_add: false,
      open_edit: false,
      open_preview: false,
      supply_detail_id: "",
      preview_data: {},
      role: "",
      
      // iframe相关
      iframeLoading: false,
      iframeKey: 0
    };
  },
  computed: {
    // 根据您提供的链接格式构造预览URL
    previewUrl() {
      if (!this.preview_data.supply_detail_id) return '';
      
      // 根据您提供的链接格式：https://xcx.shanglianweilai.com/h5/#/plus/pages/company/info?type=1%3Fuser_id%3D426&role=company&supply_detail_id=6
      const baseUrl = 'https://xcx.shanglianweilai.com/h5/#/plus/pages/company/info';
      
      // 构造参数
      const params = new URLSearchParams({
        type: '1',
        role: this.role || 'company',
        supply_detail_id: this.preview_data.supply_detail_id
      });
      
      // 如果有用户ID，可以添加
      if (this.form.user_id) {
        params.append('user_id', this.form.user_id);
      }
      
      return `${baseUrl}?${params.toString()}`;
    }
  },
  created() {
    this.form.supply_id = this.$route.query.supply_id;
    this.role = this.$route.query.role || '';
    this.getData();
    this.getGradeList();
    this.getDetailList();
  },
  methods: {
    /*获取企业数据*/
    getData() {
      let self = this;
      self.loading = true;
      SupplyApi.getSupply({ supply_id: self.form.supply_id }, true)
        .then(res => {
          if (res.code === 1) {
            let tempForm = res.data.detail;
            tempForm.supply_id = self.form.supply_id;
            self.form = tempForm;
            self.form.file_path = tempForm.image_url;
            
            if (tempForm.shop_user && tempForm.shop_user.user_name) {
              self.form.user_name = tempForm.shop_user.user_name;
            } else {
              self.form.user_name = '';
            }
            
            if (tempForm.shop_user && tempForm.shop_user.notice) {
              self.form.notice = tempForm.shop_user.notice + "";
            } else {
              self.form.notice = "";
            }
            
            if (!self.form.product_show) {
              self.form.product_show = 'two_column';
            }
          } else {
            self.$message.error('获取企业信息失败');
          }
          self.loading = false;
        })
        .catch(error => {
          self.loading = false;
          self.$message.error('获取企业信息时发生错误');
        });
    },

    /*获取详情列表*/
    getDetailList() {
      let self = this;
      self.detailLoading = true;
      let Params = {
        search: self.form.supply_id,
        page: 1,
        list_rows: 20
      };
      
      Supply_detailApi.list(Params, true)
        .then(data => {
          if (data.code === 1) {
            self.detailTableData = data.data.list.data || [];
            self.hasDetail = self.detailTableData.length > 0;
            console.log('详情列表数据:', self.detailTableData);
          } else {
            self.$message.error('获取详情列表失败');
          }
          self.detailLoading = false;
        })
        .catch(error => {
          self.detailLoading = false;
          self.$message.error('获取详情列表时发生错误');
        });
    },

    /*获取角色列表*/
    getGradeList() {
      let self = this;
      SupplyApi.gradeListsx('', true)
        .then(res => {
          if (res.code === 1) {
            self.gradeList = res.data.list.data;
            self.app_id = res.data.app_id;
            self.category = res.data.category;
          } else {
            self.$message.error('获取角色列表失败');
          }
        })
        .catch(error => {
          self.$message.error('获取角色列表时发生错误');
        });
    },

    /*提交表单*/
    onSubmit() {
      let self = this;
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          let params = { ...self.form };
          
          SupplyApi.saveSupply(params, true)
            .then(data => {
              self.loading = false;
              if (data.code === 1) {
                self.$message({
                  message: '恭喜你，修改成功',
                  type: 'success'
                });
                self.cancelFunc();
              } else {
                self.$message.error(data.message || '修改失败');
              }
            })
            .catch(error => {
              self.loading = false;
              self.$message.error('提交时发生错误');
            });
        }
      });
    },

    /*添加详情*/
    addClick() {
      console.log('打开添加弹窗');
      this.open_add = true;
    },

    /*关闭添加弹窗*/
    closeAddFunc(e) {
      console.log('关闭添加弹窗，参数:', e);
      this.open_add = false;
      if (e === 'success') {
        this.getDetailList();
        this.$message({
          message: '添加详情成功',
          type: 'success'
        });
      }
    },

    /*关闭编辑弹窗*/
    closeEditFunc(e) {
      console.log('关闭编辑弹窗，参数:', e);
      this.open_edit = false;
      this.supply_detail_id = "";
      if (e === 'success') {
        this.getDetailList();
        this.$message({
          message: '编辑详情成功',
          type: 'success'
        });
      }
    },

    /*关闭预览弹窗*/
    closePreviewFunc() {
      console.log('关闭预览弹窗');
      this.open_preview = false;
      this.preview_data = {};
      this.iframeLoading = false;
    },

    /*预览详情*/
    previewClick(row) {
      console.log('预览数据:', row);
      this.preview_data = { ...row };
      this.open_preview = true;
      this.iframeLoading = true;
      console.log('生成的预览链接:', this.previewUrl);
    },

    /*编辑详情*/
    editClick(row) {
      console.log('编辑数据:', row);
      this.supply_detail_id = row.supply_detail_id;
      this.open_edit = true;
    },

    /*删除详情*/
    deleteClick(row) {
      let self = this;
      self.$confirm("此操作将永久删除该详情信息, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          Supply_detailApi.del(
            {
              supply_detail_id: row.supply_detail_id
            },
            true
          )
            .then(data => {
              if (data.code == 1) {
                self.$message({
                  message: "删除成功",
                  type: "success"
                });
                this.getDetailList();
              } else {
                self.$message.error(data.message || "删除失败");
              }
            })
            .catch(error => {
              self.$message.error("删除时发生错误");
            });
        })
        .catch(() => {
          self.$message.info("已取消删除");
        });
    },

    /*取消返回*/
    cancelFunc() {
      this.$router.back(-1);
    },

    /*iframe加载完成*/
    iframeLoaded() {
      console.log('iframe加载完成');
      this.iframeLoading = false;
    },

    /*刷新iframe*/
    refreshIframe() {
      this.iframeLoading = true;
      this.iframeKey += 1; // 通过改变key来强制重新加载iframe
      console.log('刷新iframe，新链接:', this.previewUrl);
    },

    /*在新窗口打开*/
    openInNewWindow() {
      if (this.previewUrl) {
        window.open(this.previewUrl, '_blank');
        this.$message.success('已在新窗口打开预览页面');
      } else {
        this.$message.warning('预览链接不存在');
      }
    },

    /*复制预览链接*/
    copyPreviewLink() {
      if (this.previewUrl) {
        // 使用现代浏览器的 Clipboard API
        navigator.clipboard.writeText(this.previewUrl).then(() => {
          this.$message.success('预览链接已复制到剪贴板');
        }).catch(err => {
          // 降级方案
          const textArea = document.createElement('textarea');
          textArea.value = this.previewUrl;
          document.body.appendChild(textArea);
          textArea.select();
          try {
            document.execCommand('copy');
            this.$message.success('预览链接已复制到剪贴板');
          } catch (err) {
            this.$message.error('复制失败，请手动复制链接');
          }
          document.body.removeChild(textArea);
        });
      } else {
        this.$message.warning('预览链接不存在');
      }
    }
  }
};
</script>

<style scoped>
.detail-management-section {
  padding: 20px;
  background: #fff;
  margin-top: 30px;
  border: 1px solid #e6e6e6;
  border-radius: 4px;
}

.tip-text {
  margin-top: 10px;
  color: #909399;
  font-size: 12px;
}

.tip-text i {
  margin-right: 5px;
}

.loading-container {
  text-align: center;
  padding: 40px;
  color: #909399;
}

.loading-container i {
  margin-right: 8px;
}

.common-level-rail {
  margin: 20px 0;
}

.common-form {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid #ebeef5;
}

/* 预览相关样式 */
.preview-container {
  position: relative;
}

.preview-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid #ebeef5;
}

.preview-title {
  font-size: 16px;
  font-weight: bold;
  color: #303133;
}

.preview-actions {
  display: flex;
  gap: 10px;
}

.iframe-container {
  position: relative;
  border: 1px solid #e6e6e6;
  border-radius: 4px;
  overflow: hidden;
  background: #f5f5f5;
}

.preview-loading {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  color: #909399;
  background: rgba(255, 255, 255, 0.95);
  padding: 20px 30px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  z-index: 10;
}

.preview-loading i {
  margin-right: 8px;
  font-size: 18px;
}

.dialog-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>

<style>
/* 全局样式，用于预览对话框 */
.preview-dialog .el-dialog__body {
  padding: 20px;
}

.preview-dialog .el-dialog__header {
  border-bottom: 1px solid #e6e6e6;
  padding: 15px 20px;
  background: #fafafa;
}

.preview-dialog .el-dialog__footer {
  border-top: 1px solid #e6e6e6;
  padding: 15px 20px;
  background: #fafafa;
}

.preview-dialog .el-dialog {
  border-radius: 8px;
  overflow: hidden;
}
</style>


// WEBPACK FOOTER //
// src/views/plus/supply/supply/edit.vue